<template>

    <section v-if="$store.state.isLoggedIn != null && $store.state.isLoggedIn === false" class="customer-portal-login container-fluid w-100">

        <div class="row d-flex align-items-center h-100">

            <!-- Login main picture -->
            <div class="col-lg-8 col-md-7 left-column d-none d-md-block">
                <div class="login-main-picture d-flex justify-content-center">
                    <img src="/images/customer-portal-login.png" alt="Login img">
                </div>
            </div>

            <!-- Right column (Login Form) -->
            <div class="col-lg-4 col-md-5 col-12 right-column h-100 d-flex flex-column justify-content-center align-items-center">

                <!-- Company details (Name & logo) -->
                <div class="company-details d-flex flex-column justify-content-center align-items-center mb-5">
                    <img v-if="company_logo" :src="company_logo" class="company-logo img-fluid d-block mx-auto" alt="">
                    <img v-else src="../assets/favicon.png" class="img-fluid d-block mx-auto" alt="">
                    <h2 class="company-name mb-0">{{ $store.getters.company.company_name }}</h2>
                </div>

                <!-- Login Form -->
                <el-form 
                    :model="loginForm" 
                    :rules="rules" 
                    ref="loginForm"
                    :hide-required-asterisk="true" 
                    class="login-form px-0 px-md-3 w-100" 
                    method="post" 
                    action="/login" 
                    v-on:submit.prevent="processLogin()"
            >
                    <input type="hidden" name="_token" value="" v-model="token">

                    <!-- Company Email Input -->
                    <el-form-item prop="email" label="Your Email" class="company-email">
                        <el-input v-model="loginForm.email" type="email" name="email" placeholder="john@example.com" aria-required="" />
                    </el-form-item>

                    <!-- Password Input -->
                    <el-form-item prop="password" label="Password" class="company-email">
                        <el-input v-model="loginForm.password" name="password" type="password" aria-required="" />
                    </el-form-item>

                    <!-- <div class="col-12 text-center"> -->
                        <!-- <p class="mb-0 mt-3"><small class="text-dark mr-2">Don't have an account ?</small>
                            <router-link to="/signup" class="text-dark font-weight-bold">Sign Up</router-link>
                        </p> -->
                    <!-- </div> -->

                    <!-- Submit button -->
                    <el-button type="primary" class="w-100" @click.stop.prevent="processLogin()">Login</el-button>

                    <!-- Forgot Password -->
                    <div class="password-reset d-flex justify-content-end">
                        <router-link to="/password-reset" class="forgot-password">Forgot password?</router-link>
                    </div>


                </el-form>

            </div>

        </div>

    </section>

</template>


<script>

    import { HomeIcon, UserIcon, KeyIcon } from 'vue-feather-icons';

    /* Auth-login component */

    export default {

        data() {
            return {
                token: '',
                loginForm: {
                    email: '',
                    password: '',
                },
                request_sent : false,
                rules: {
                    email: [
                        { required: true, message: 'Email Address is required', trigger: ['blur', 'change'] },
                        { type: 'email', message: 'Please insert a valid email address', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: 'Password is required', trigger: ['blur', 'change'] },
                    ]
                },
            }
        },

        mounted(){
            // console.log(this.$store.getters.company)
        },

        components: {
            HomeIcon,
            UserIcon,
            KeyIcon
        },

        computed:{
            company_logo() {

                if (this.$store.getters.company.company_logo)
                    return (
                        import.meta.env.VITE_APP_URL + '/' +
                        this.$store.getters.company.company_logo.replace(
                            "public",
                            "storage"
                        )
                    );
            },
        },

        methods: {
            validateEmail() {
                if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.loginForm.email))
                {
                    return true
                }

                return false
            },

            processLogin () {

                this.$refs['loginForm'].validate((valid, errors) => {

                    if (valid) {

                        if(this.loginForm.email && this.loginForm.password ){

                            this.$store.dispatch("auth_login", {
                                email: this.loginForm.email,
                                password: this.loginForm.password
                            })
                        }
                    }
                })
            }
        }
    }

</script>

<style src='bootstrap/dist/css/bootstrap.css' scoped></style>

<style lang="scss" scoped>

    .customer-portal-login {
        background-color: #FAFAFA;
        height: 100vh;
    }

    .login-main-picture img {
        max-width: 550px;
    }

    .customer-portal-login .right-column {
        background-color: white;
    }

    .company-details img {
        max-width: 125px;
        width: 100%;
    }

    .company-name {
        font-size: 20px;
        font-weight: 500;
        text-transform: capitalize;
    }

    .company-logo {
        margin-bottom: 35px;
    }

    .el-form-item::v-deep {

        margin-bottom: 24px;

        .el-input__inner {
            box-sizing: border-box;
            border: 1px solid #EAEAEA;
            border-radius: 12px;
            padding: 0 16px;
            height: 44px;
            font-size: 14px;
            font-weight: 500;
            color: #072540;
        }

        &.is-error {
            .el-input__inner {
                border-color: #E95A5A;
            }
        }

    }

    .el-button--primary {
        background-color: #072540;
        border-color: #072540;
        border-radius: 12px;
        height: 44px;
        font-weight: 500;
        font-size: 14px;
        margin-top: 16px;
    }

    .password-reset {
        margin: 12px 0 12px;

        .forgot-password {
            color: #E95A5A;
            font-weight: 500;
            font-size: 13px;
            line-height: 22px;
        }
    }

</style>

